import { render, staticRenderFns } from "./MMP_VersionRelease.vue?vue&type=template&id=f62b8c60&"
import script from "./MMP_VersionRelease.vue?vue&type=script&lang=js&"
export * from "./MMP_VersionRelease.vue?vue&type=script&lang=js&"
import style0 from "./MMP_VersionRelease.vue?vue&type=style&index=0&id=f62b8c60&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports